document.addEventListener('DOMContentLoaded', function () {
  const desktopVideo = document.getElementById('desktop-video');
  const mobileVideo = document.getElementById('mobile-video');
  const toggleBtn = document.getElementById('video-toggle');

  if (!toggleBtn) return;

  const playIcon = toggleBtn.querySelector('.icon-play');
  const pauseIcon = toggleBtn.querySelector('.icon-pause');

  let isPaused = false; 

  function pauseAll() {
    if (desktopVideo) desktopVideo.pause();
    if (mobileVideo) mobileVideo.pause();
    playIcon.style.display = 'inline';
    pauseIcon.style.display = 'none';
    isPaused = true;
  }

  function playAll() {
    if (desktopVideo) desktopVideo.play().catch(() => {});
    if (mobileVideo) mobileVideo.play().catch(() => {});
    playIcon.style.display = 'none';
    pauseIcon.style.display = 'inline';
    isPaused = false;
  }

  // Initial state (autoplay ON)
  playAll();

  toggleBtn.addEventListener('click', function () {
    if (isPaused) {
      playAll();
    } else {
      pauseAll();
    }
  });

  // Sync on resize (prevents mobile autoplay issue)
  window.addEventListener('resize', function () {
    if (isPaused) pauseAll();
    else playAll();
  });
});
